import axios from "axios";

const CENTER_API_URL = process.env.REACT_APP_CENTERSERVICE_URL;

export const GET_LACK_OF_WALLET_DEVICE_REQUEST_SMS_SENT_COUNT = `${CENTER_API_URL}/api/v1/Device/GetLackOfWalletDeviceRequestSMSSentCount`;

export function GetLackOfWalletDeviceRequestSMSSentCount(
  ProducerCenterId: string | undefined
) {
  let url = `${GET_LACK_OF_WALLET_DEVICE_REQUEST_SMS_SENT_COUNT}?ProducerCenterId=${ProducerCenterId}`;
  let data = axios.post(url).catch((error) => {
    return error;
  });
  return data;
}
